module.exports = __webpack_public_path__ + "static/dc-shop.00231e5c.jpg";